<template>
	<div id="developer" class='gcardfr' v-loading='loading'>
		<el-row class=''>
			<el-col :span='16'>
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addTer'>{{ $t('deleloper.add_develop') }}</el-button>
			</el-col>
			<el-col :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('app_select_account') }}：</label>
					<el-input size='small' placeholder="id" v-model='srcKey' @keyup.enter.native="indexget"></el-input>
				</div>
			</el-col>
		</el-row>
		<!-- @selection-change="batchSelected" -->
		<el-table ref="multipleTable" class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="accessid" :label="$t('deleloper.develop_id')" width="">
			</el-table-column>
			<el-table-column prop="productName" :label="$t('deleloper.product_model')" width="">
			</el-table-column>
			<el-table-column prop="name" width="140" :label="$t('deleloper.develop_name')">
			</el-table-column>
			<el-table-column prop="agentName" width="140" :label="$t('terminal.app_distributor')">
			</el-table-column>
			<el-table-column prop="aliProductKey" :label="$t('app_aliyun')" width="">
			</el-table-column>	
			<el-table-column prop="phone" :label="$t('app_mobile_phone')" width="">
			</el-table-column>
			<el-table-column prop="email" :label="$t('app_email')" width="">
			</el-table-column>
			<el-table-column prop="address" :label="$t('app_addres')" width="">
			</el-table-column>
			<el-table-column prop="enable" :label="$t('app_status')" :formatter="setDevpSt" width="">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_add_time')" width="170">
			</el-table-column>
			<el-table-column :label="$t('app_operation')" width="120">
				<template slot-scope="scope">
					<el-button @click='editDeveloper(scope.row)' type='text'>{{ $t('app_edit') }}</el-button>
					<label class='opbline'>|</label>
					<el-button @click='delRow(scope.row.accessid)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog @close="closeDia" id='ddia' class='gstdia' :title="isEdit? $t('deleloper.edit_develop') : $t('deleloper.add_develop') " :visible.sync="showDia">
			<!-- <div style="overflow: scroll;height: calc(100% - 110px);position:relative;">
      </div> -->
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('deleloper.develop_id')" :label-width="$formlbWidth" prop='accessid'>
					<el-input v-model="tform.accessid" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_password')" :label-width="$formlbWidth" prop='accesskey'>
					<el-input v-model="tform.accesskey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.product_model')" :label-width="$formlbWidth" prop='productModel'>
					<Model :config='mconfig'></Model>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_name')" :label-width="$formlbWidth" prop='name'>
					<el-input v-model="tform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_phone')" :label-width="$formlbWidth" prop='phone'>
					<el-input v-model="tform.phone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_email')" :label-width="$formlbWidth" prop='email'>
					<el-input v-model="tform.email" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('deleloper.develop_address')" :label-width="$formlbWidth" prop='address'>
					<el-input v-model="tform.address" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop='user_list'>
					<!-- <Merchant :config='sortMc'></Merchant> -->
					<el-select v-model="tform.user_list" clearable filterable multiple :placeholder="$t('app_select')"
						style="width: 100%;">
						<el-option v-for="(item,index) in user_list" :key="index" :label="item.agentName"
							:value="item.clientKey"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('app_aliyun')" :label-width="$formlbWidth" prop='aliProductKey'>
					<el-input v-model="tform.aliProductKey" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_status')" :label-width="$formlbWidth">
					<el-radio v-model="tform.enable" :label="0">{{ $t('app_disabled') }}</el-radio>
					<el-radio v-model="tform.enable" :label="1">{{ $t('app_enable') }}</el-radio>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="showDia = false">{{ $t('app_cancel') }}</el-button>
					<el-button type="primary" @click="rqsBefore">{{ $t('app_sure') }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<style>
	/* #ddia {
    height: 100% !important; 
    overflow: hidden !important;   
  }
  #ddia .el-dialog {
    height: 70% !important;        
  }
  #ddia .el-dialog__body {    
    height: 100% !important;    
  } */
</style>

<script>
	import Pages from '@/components/Pages.vue'
	import Model from '@/components/Model.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				mconfig: {},
				srcKey: '',
				pconfig: '',
				tableData: [],
				sortMc: {},
				showDia: false,
				tform: {
					id: '',
					accessid: '',
					productModel: '',
					accesskey: '',
					name: '',
					phone: '',
					email: '',
					address: '',
					enable: 1,
					mech: '',
					aliProductKey:"",
					user_list:[]
				},
				user_list: [],
				page: 1,
				total: 0,
				loading: false,
				// sRows: [],
				isEdit: false,
				rules: {
					accessid: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					productModel: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					accesskey: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					email: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					mech: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					address: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
				}
			}
		},
		components: {
			Pages,
			Model,
			Merchant
		},
		methods: {
			initMc(mcvl) {
				var _this = this
				this.sortMc = {
					size: '',
					isbc: true,
					value: mcvl,
					vlkey: 'clientKey',
					callback: (vl) => {
						_this.tform.mech = vl ? vl.toString() : ''
					}
				}
			},
			indexget() {
				this.page = 1
				this.getList()
			},
			setModelCtrl(val) {
				var _this = this
				this.mconfig = {
					size: '',
					isbatch: true,
					value: val,
					callback: vl => {
						_this.tform.productModel = vl
					}
				}
			},
			setDevpSt(row) {
				return this.$devpSt[row.enable]
			},
			// batchDel () {
			//   this.$showMsgBox('确定删除这些数据？',() => {
			//     var arr = []
			//     this.sRows.forEach(item => {
			//       arr.push(item.id)
			//     })     
			//     this.delRqs(arr.toString())
			//   },'') 
			// },
			delRqs(id) {
				this.loading = true
				this.$delDevlp(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			delRow(id) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(id)
				}, '')
			},
			addTer() {
				this.isEdit = false
				this.showDia = true
				// this.getProductModel();
				// this.initMc('')
				this.get_mechan_list();
			},
			// toDetail (row) {      
			//   this.$router.push({path: '/equipment/detail', query: {id: row.id}})
			// },
			getList() {
				var productKey = this.srcKey ? this.srcKey : ''
				this.loading = true;
				this.$devList(this.page, this.$gRow, productKey, res => {
					this.loading = false;
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
						//console.log('getList '+JSON.stringify(res.data))
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			get_mechan_list(){
				this.$agentCtrlList(res => {
				    if (res.status == 200) {                 
				      this.user_list = res.data
				      // alert(this.slvl + ' ' + this.vlkey + ' rfrs')
				    }
				  }, '')
			},
			// batchSelected (val) {
			//   this.sRows = val
			// },
			closeDia() {
				this.showDia = false
				this.tform = {
					accessid: '',
					productkey: '',
					productModel: '',
					accesskey: '',
					name: '',
					phone: '',
					email: '',
					address: '',
					aliProductKey:"",
					enable: 1,
					mech: '',
					user_list:[]
				}
				this.setModelCtrl('')
				this.rfForm()
			},
			rfForm() {
				this.$refs['ruleForm'].resetFields()
			},
			rqsBefore() {

				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {
				this.tform.mech = String(this.tform.user_list) // 转为字符串
				if (!this.isEdit) {
					this.$addDeveloper(this.tform.accessid, this.tform.productModel.toString(), this.tform.accesskey, this
						.tform.name, this.tform.phone, this.tform.email, this.tform.address, this.tform.enable, this
						.tform.mech,this.tform.aliProductKey, res => {
							if (res.status == 200) {
								this.closeDia();
								this.getList()
							} else {
								this.$message.error(res.message)
							}
						}, '')
				} else {
					this.$editDeveloper(this.tform.id, this.tform.productModel.toString(), this.tform.accessid, this.tform
						.accesskey, this.tform.name, this.tform.phone, this.tform.email, this.tform.address, this.tform
						.enable, this.tform.mech.toString(),this.tform.aliProductKey, res => {
							if (res.status == 200) {
								this.closeDia();
								this.getList()
							} else {
								this.$message.error(res.message)
							}
						}, '')
				}
			},
			getDetails(row) {
				console.log("developer details = " + row.id);
			},
			editDeveloper(row) {
				this.tform.id = row.accessid
				this.tform.accessid = row.accessid
				this.tform.productkey = row.productkey;
				this.tform.accesskey = row.accessKey;
				this.tform.name = row.name;
				this.tform.phone = row.phone;
				this.tform.email = row.email;
				this.tform.address = row.address;
				this.tform.enable = row.enable;
				// this.tform.mech = row.clientKey ? row.clientKey.split(',') : []
				this.tform.mech = "";
				this.tform.aliProductKey = row.aliProductKey;
				
				this.tform.productModel = row.productKey ? row.productKey.split(',') : []
				this.setModelCtrl(this.tform.productModel)
				
				this.tform.user_list = row.clientKey ? row.clientKey.split(',') : [] // 字符串转列表
				
				console.log(row)
				console.log(this.tform.mech)
				this.isEdit = true
				this.showDia = true
				this.get_mechan_list();
				// this.initMc(this.tform.mech)
			},
			// getProductModel(){
			//   this.loading = true
			//   let productKey = ''
			//    this.$models(this.page, this.$gRow, productKey, res => {
			//     this.loading = false
			//     if (res.status == 200) {
			//       this.optionsProductModel = res.data
			//     } else {
			//       this.$message.error(res.message)
			//     }
			//   }, '')
			// }
		},

		mounted() {
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

			this.setModelCtrl('')

			this.getList()
		}
	}
</script>
